const Constants = {
    // BASE_URL: "https://toiyabe-app.novocent.com/api",
    BASE_URL: "https://app.toiyabe.us/api/",
    ACCEPTED_VIDEO_TYPES: "video/mp4,video/ogg,video/quicktime",
}

export default Constants;